import classnames from 'classnames';
import React from 'react';

import '@eika/link-panel-style';
import { Polymorph } from '@eika/polymorph';

import { LinkPanelAdvancedProps } from './LinkPanelTypes';
import { Tags, PanelArrow, TextContent } from './components';
import useGenerateId from './hooks/useGenerateId';

export const LinkPanelAdvanced = ({
    url,
    title,
    textOne,
    textTwo,
    textThree,
    tags,
    ariaLabel,
    icon,
    advancedIcon,
    className,
    as,
    invertIcon = false,
    ...rest
}: LinkPanelAdvancedProps): JSX.Element => {
    const textContent = { title, textOne, textTwo, textThree };
    const hasTextContent = textOne || tags || textTwo || textThree;
    const targetIcon = icon ?? advancedIcon;
    const hasIcon = Boolean(targetIcon);

    const labelId = useGenerateId();

    return (
        <Polymorph
            as={as}
            className={classnames(
                'sgw-link-panel-advanced',
                { 'inverted-icon': invertIcon },
                { 'align-center': !hasTextContent },
                { 'no-right-icon': !hasIcon },
                className,
            )}
            aria-labelledby={labelId}
        >
            <a className="sgw-link-panel-advanced__link" href={url} aria-label={ariaLabel} {...rest}>
                <Tags className="sgw-link-panel-advanced__labels" tags={tags} />
                <TextContent id={labelId} prefixClass="sgw-link-panel-advanced" {...textContent} />
                <PanelArrow className="sgw-link-panel-advanced__arrow-wrapper" show={hasIcon} icon={targetIcon} />
            </a>
        </Polymorph>
    );
};
